// BlogsPage.jsx
import React, { useState, useMemo } from "react";
import AIJudiciary from "../../assets/AIJudiciary.webp";
import GraphSummit from "../../assets/GraphSummit.webp";
import GenAIvsConAI from "../../assets/blogs/GenAIvsConAI/thumbnail.png";
import AskVijay from "../../assets/askVijay.png";
import Venkat from "../../assets/venkat.jpg";
import Header from "../../components/header";
import Footer from "../../components/Footer";
import BlogTile from "../../components/BlogTile";
import "./BlogsPage.css";

const BlogsPage = () => {
  // Sample blog data - in a real app, this would come from an API
  const allBlogs = [
    {
      id: 1,
      title: "கேள்வி கேள்! விஜயிடம் கேள்வி கேள்!",
      slug: "askVijay",
      excerpt:
        "கேள்வி கேள்! விஜயிடம் கேள்வி கேள்! த.வெ.க-விடம் கேள்வி கேள்!கேள்வி கேட்கும் உரிமை உன்னிடம் முழுமையாக உள்ளது.",
      image: AskVijay,
      author: "",
      authorImage: "",
      publishDate: "February 9, 2026",
      tags: ["Politics", "TNElections", "Vijay", "TVK"],
    },
    {
      id: 2,
      title: "Use of AI in the Indian Judiciary",
      slug: "ai-in-judiciary",
      excerpt:
        "Exploring how AI is transforming the Indian judiciary to enhance efficiency, reduce case backlogs, and deliver faster justice",
      image: AIJudiciary,
      author: "Venkatesh",
      authorImage: Venkat,
      publishDate: "March 10, 2025",
      tags: ["AI", "Judiciary", "Society"],
    },
    {
      id: 3,
      title:
        "Graph Summit 2025: Unveiling the Power of Knowledge Graphs in AI & LLMs",
      slug: "graphsummit-25",
      excerpt:
        "Insights from Neo4j's Graph Summit 2025—exploring GraphRAG, digital twins, and Neo4j’s future in the cloud.",
      image: GraphSummit,
      author: "Venkatesh",
      authorImage: Venkat,
      publishDate: "April 01, 2025",
      tags: ["Knowledge graph", "Event", "AI"],
    },
    {
      id: 4,
      title:
        "The Marriage of Conversational AI and Generative AI: Structure Meets Creativity",
      slug: "genai-vs-conai",
      excerpt:
        "Discover how Conversational AI is quietly evolving by weaving in Generative AI — blending structure with creativity to deliver smarter, more humanlike interactions.",
      image: GenAIvsConAI,
      author: "Venkatesh",
      authorImage: Venkat,
      publishDate: "August 04, 2025",
      tags: ["Gen AI", "Conversational AI", "Kore.ai"],
    },

    // Add more blog entries...
  ];

  // State for filters
  const [selectedTag, setSelectedTag] = useState("");
  const [sortBy, setSortBy] = useState("newest");
  const [searchQuery, setSearchQuery] = useState("");

  // Get unique tags from blogs
  const uniqueTags = useMemo(() => {
    const tagSet = new Set();
    allBlogs.forEach((blog) => {
      blog.tags.forEach((tag) => tagSet.add(tag));
    });
    return Array.from(tagSet).sort();
  }, [allBlogs]);

  // Filter and sort blogs
  const filteredAndSortedBlogs = useMemo(() => {
    return (
      allBlogs
        // First apply tag filter
        .filter((blog) =>
          selectedTag ? blog.tags.includes(selectedTag) : true
        )
        // Then apply search filter
        .filter((blog) => {
          const searchLower = searchQuery.toLowerCase();
          return (
            blog.title.toLowerCase().includes(searchLower) ||
            blog.excerpt.toLowerCase().includes(searchLower) ||
            blog.author.toLowerCase().includes(searchLower) ||
            blog.tags.some((tag) => tag.toLowerCase().includes(searchLower))
          );
        })
        // Finally sort
        .sort((a, b) => {
          switch (sortBy) {
            case "newest":
              return new Date(b.publishDate) - new Date(a.publishDate);
            case "oldest":
              return new Date(a.publishDate) - new Date(b.publishDate);
            default:
              return 0;
          }
        })
    );
  }, [allBlogs, selectedTag, sortBy, searchQuery]);

  return (
    <div className="blogs-page">
      <Header />
      <main className="blogs-container">
        <div className="blogs-header">
          <h1>Latest Articles</h1>
          {/* <div className="search-bar">
            <input
              type="text"
              placeholder="Search articles..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
          </div> */}
          <div className="blogs-filters">
            <select
              className="filter-select"
              value={selectedTag}
              onChange={(e) => setSelectedTag(e.target.value)}
            >
              <option value="">All Tags</option>
              {uniqueTags.map((tag) => (
                <option key={tag} value={tag}>
                  {tag}
                </option>
              ))}
            </select>
            <select
              className="filter-select"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="newest">Newest First</option>
              <option value="oldest">Oldest First</option>
            </select>
          </div>
        </div>

        {/* Tag chips for quick filtering */}
        {/* <div className="tag-chips">
          <button
            className={`tag-chip ${selectedTag === "" ? "active" : ""}`}
            onClick={() => setSelectedTag("")}
          >
            All
          </button>
          {uniqueTags.map((tag) => (
            <button
              key={tag}
              className={`tag-chip ${selectedTag === tag ? "active" : ""}`}
              onClick={() => setSelectedTag(tag)}
            >
              {tag}
            </button>
          ))}
        </div> */}

        {filteredAndSortedBlogs.length > 0 ? (
          <div className="blogs-grid">
            {filteredAndSortedBlogs.map((blog) => (
              <BlogTile key={blog.id} blog={blog} />
            ))}
          </div>
        ) : (
          <div className="no-results">
            <p>No articles found matching your criteria.</p>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default BlogsPage;
